import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=59eb4686&scoped=true"
import script from "./Marketplace.vue?vue&type=script&lang=ts"
export * from "./Marketplace.vue?vue&type=script&lang=ts"
import style0 from "./Marketplace.vue?vue&type=style&index=0&id=59eb4686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eb4686",
  null
  
)

export default component.exports